export const SET_MY_QUESTS_AUTHOR_FILTER = 'SET_MY_QUESTS_AUTHOR_FILTER'
export const SET_MY_QUESTS_ASSIGNED_TO_FILTER =
  'SET_MY_QUESTS_ASSIGNED_TO_FILTER'
export const SET_MY_QUESTS_KEYWORD_FILTER = 'SET_MY_QUESTS_KEYWORD_FILTER'
export const SET_MY_QUESTS_DRAFT_FILTER = 'SET_MY_QUESTS_DRAFT_FILTER'
export const SET_MY_QUESTS_STATUS_FILTER = 'SET_MY_QUESTS_STATUS_FILTER'

export function setAuthorFilter(authorIds) {
  return {
    type: SET_MY_QUESTS_AUTHOR_FILTER,
    authors_id_in: authorIds
  }
}

export function setKeywordFilter(keyword) {
  return {
    type: SET_MY_QUESTS_KEYWORD_FILTER,
    name_or_description_cont: keyword
  }
}

export function setDraftFilter(val) {
  return {
    type: SET_MY_QUESTS_DRAFT_FILTER,
    quest_draft_or_state_in: val
  }
}

export function setStatusFilter(statuses) {
  return {
    type: SET_MY_QUESTS_STATUS_FILTER,
    reviewing_compiled_quest_state_in: statuses
  }
}

export function setAssignedToFilter(assignedToIds) {
  return {
    type: SET_MY_QUESTS_ASSIGNED_TO_FILTER,
    assigned_to_id_in: assignedToIds
  }
}



// WEBPACK FOOTER //
// ./src/actions/myquestsfilters.js